/*
 * @Author: qiuwenjing qiuwenjing@vip56.cn
 * @Date: 2023-03-10 14:05:59
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2023-03-28 09:10:48
 * @FilePath: \projectManagementFrontd:\project\vue\2022\PosManager-Front\src\http\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Public } from './api_Public';
import { TbSettings } from './api_TbSettings';
import { TbOrder } from './api_TbOrder';
import { TbShopAccount } from './api_TbShopAccount';
import { TbShop } from './api_TbShop';
import { TbGoodsClass } from './api_TbGoodsClass';
import { TbGoods } from './api_TbGoods';
import { TbGoodsSpecs } from './api_TbGoodsSpecs';
import { TbSupplier } from './api_TbSupplier';
import { TbSettingsPad } from './api_TbSettingsPad';
import { TbGrade } from './api_TbGrade';
import { TbMember } from './api_TbMember';
import { TbRole } from './api_TbRole';
import { TbCommissionRule } from './api_TbCommissionRule';
import { TbReport } from './api_TbReport';
import { TbInventory } from './api_TbInventory';
import { TbOrderPad } from './api_TbOrderPad';
import { TbTransferOrder } from './api_TbTransferOrder';
import { TbCoupon } from './api_TbCoupon';
import { TbExChangeGoods } from './api_TbExChangeGoods';
import { TbReturnOrder } from './api_TbReturnOrder';
import { TbTbHandover } from './api_TbTbHandover';
import { TbNotice } from './api_TbNotice';
import { AliyunPad } from './api_AliyunPad';
import { TbPickupOrder } from './api_TbPickupOrder';

export {
    Public,
    TbSettings,
    TbOrder,
    TbShopAccount,
    TbShop,
    TbGoodsClass,
    TbGoods,
    TbGoodsSpecs,
    TbSupplier,
    TbSettingsPad,
    TbGrade,
    TbMember,
    TbRole,
    TbCommissionRule,
    TbReport,
    TbInventory,
    TbOrderPad, 
    TbTransferOrder,
    TbCoupon,
    TbExChangeGoods,
    TbReturnOrder,
    TbTbHandover,
    TbNotice,
    AliyunPad,
    TbPickupOrder,
};


// WEBPACK FOOTER //
// ./src/http/index.ts